import { validateMachine } from '../../../../helpers/table-cell-validators'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard, renderShipment } from '../../helpers/helpers'
import ShipmentMachineBrandWrapper from '../../components/cells/form-items/shipment-machine-brand-wrapper'

export const machineNameColumn: ShipmentColumn = {
    key: 'machine',
    dataIndex: ['machine', 'name'],
    relationPath: ['machine'],
    title: 'Станок',
    width: 70,
    editable: true,
    FormItem: <ShipmentMachineBrandWrapper />,
    validator: validateMachine,
    render: renderShipment(shipment => shipment?.machine?.name.split(' ')[0]),
    onCell: onCellStandard,
}
